import { set } from "date-fns";
import { useEffect, useState } from "react";

type FormattedData = {
  leafWetness: string | null;
  soilMoisture: string | null;
  leafWetnessValue: number | null;
  soilMoistureValue: number | null;
  date: string;
  time: string;
};

type Props = {
  channelId: number;
  field4: number;
  field1: number;
  results: number;
};
type Entry = {
  created_at: string;
  entry_id: number;
  field1: string | null;
  field4: string | null;
};

function convertEntriesToISTFormat(entries: Entry[]): FormattedData[] {
  return entries.map((entry) => {
    const dateObj = new Date(entry.created_at);

    const istDate = new Date(
      dateObj.toLocaleString("en-US", {
        timeZone: "Asia/Kolkata",
      }),
    );

    const date = istDate.toDateString(); // e.g., "Sun Jun 08 2025"
    const time = istDate.toTimeString().split(" ")[0] + " GMT+0530"; // "12:34:33 GMT+0530"

    return {
      date,
      time,
      leafWetness: `Leaf Wetness: ${entry.field4 ?? "N/A"}`,
      soilMoisture: `Soil Moisture: ${entry.field1 ?? "N/A"}`,
      leafWetnessValue: Number(entry.field4), //field1
      soilMoistureValue: Number(entry.field1), //field2
    };
  });
}

export const useThingSpeakFormattedData = ({
  channelId,
  field4,
  field1,
  results,
}: Props) => {
  const [data, setData] = useState<FormattedData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const url = `https://api.thingspeak.com/channels/${channelId}/feeds.json?results=${results}?timezone=Asia%2FKolkata`;
        const response = await fetch(url);
        const json = await response.json();
        const data = convertEntriesToISTFormat(json.feeds);

        setData(data);
      } catch (err) {
        console.error(err);
        setError("Something went wrong while fetching ThingSpeak data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [channelId, field1, field4, results]);

  return { data, loading, error };
};
